import { Component, EventEmitter, Input, OnChanges, Output } from "@angular/core";
import { DoughnutChartData } from "../doughnut-chart/doughnut-chart.component";
import { InlineTableData } from "../data-table/data-table.component";

@Component({
  selector: "doughnut-summary-card",
  templateUrl: "./doughnut-summary-card.component.html",
  styleUrls: ["../../dashboard-section.scss", "../../dashboard-section-v2.scss"],
  styles: [":host { display: contents; }"],
})
export class DoughnutSummaryCardComponent implements OnChanges {
  @Input() title: string;
  @Input() hint: string;
  @Input() chartData: DoughnutChartData;
  @Input() tableData: InlineTableData;
  @Input() totalLabel: string = "Total Sessions";
  @Input() noDataMessage: string = "Nothing to see here yet.";
  @Input() showExport: boolean = true;
  @Input() showDashboardLink: boolean = false;
  @Input() isReport: boolean = false;
  @Input() comingSoon: boolean = false;
  @Input() tooltipIconMap: { [label: string]: string } = {};
  @Output() exportClick = new EventEmitter<void>();
  @Output() dashboardClick = new EventEmitter<void>();
  hasLegend: boolean = false;

  ngOnChanges() {
    this.hasLegend = false;
    if (this.tableData && this.tableData.length > 0) {
      this.hasLegend = true;
    }
  }
}
